import Select from 'react-select';
import { ClientOnly } from "remix-utils";

export function OptionsSelect({
    optionIndex,
    option,
    selected,
    label,
    isMulti = false,
    tooltip,
    required = false,
    onUpdate
}: {
    optionIndex: number,
    option: { id: string, label: string, values: any[] },
    selected: any,
    label: string,
    isMulti: boolean,
    tooltip: string,
    required: boolean,
    onUpdate: (selected: any) => void
}) {
    const getSelect = () => {
        {/* If there's no name, it won't register as a form entry */ }
        const getLabel = () => <><label className="block">{label} {required && <abbr className="no-underline text-red-500" title="required">*</abbr>}</label></>

        if (isMulti) {

            const updateMulti = (selected: any) => {
                onUpdate(selected);
            };

            return (
                <div>
                    {getLabel()}
                    <Select
                        options={option.values}
                        getOptionValue={(o: any) => o.id}
                        value={selected || []}
                        isMulti={true}
                        required={required}
                        onChange={updateMulti} />
                    {selected?.length ? selected.map((s: any, index: number) => <div key={index}>

                        <input type="hidden" name={`options[${optionIndex}].value[${index}].id`} value={s.id} required={required} />
                        <input type="hidden" name={`options[${optionIndex}].value[${index}].label`} value={s.label} required={required} />
                        <input type="hidden" name={`options[${optionIndex}].value[${index}].sku`} value={s.sku} required={required} />

                    </div>) : ''}
                </div>
            )
        } else {
            return (<div>
                {getLabel()}
                <Select
                    options={option.values}
                    getOptionValue={(o: any) => o.id}
                    value={selected || ''}
                    required={required}
                    onChange={(e: any) => onUpdate(e)} />
                {selected ? <>
                    <input type="hidden" name={`options[${optionIndex}].value.id`} value={selected?.id} required={required} />
                    <input type="hidden" name={`options[${optionIndex}].value.label`} value={selected?.label} />
                    <input type="hidden" name={`options[${optionIndex}].value.sku`} value={selected?.sku} required={required} />
                </> : ''}
            </div>)
        }
    }

    return (
        <>
            {tooltip && <p className=" w-fit bg-blue-100 text-blue-700 p-2 mb-2 rounded">{tooltip}</p>}
            {getSelect()}
            <input type="hidden" name={`options[${optionIndex}].optionId`} value={option.id} required={required} />
            <input type="hidden" name={`options[${optionIndex}].optionLabel`} value={option.label} required={required} />
        </>
    );
}

